module.exports = __webpack_public_path__ + "img/img-11.395809da.webp";